import { getApiURL } from '../environments/getApiURL';

export async function compareBuildInfo(): Promise<boolean> {
  let localBuildInfo: any = {};
  try {
    localBuildInfo = require('../assets/static/build-infos.json');
  } catch (error) {
    return true;
  }
  const url = new URL(getApiURL() + '/get-build-info');
  let hasMismatch = true;
  await fetch(encodeURI(url.href), {
    method: 'GET',
    cache: 'no-cache',
  })
    .then((response) => {
      if (response) {
        return response.text();
      }
    })
    .then((result) => {
      if (result) {
        const serverBuildInfo = JSON.parse(result);
        hasMismatch =
          serverBuildInfo.tag !== localBuildInfo.tag ||
          serverBuildInfo.commit !== localBuildInfo.commit;
      }
    })
    .catch((error) => console.error(error));
  return hasMismatch;
}
